import React from 'react';

export default function SignupLoadingSpinner({ label = 'A processar…' }) {
  return (
    <div className="flex flex-col items-center gap-4 py-4">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-iron-border border-t-iron-accent" />
      <p className="font-mono text-sm text-iron-muted">{label}</p>
    </div>
  );
}
